import { Font } from 'types'

export function fontFamily(font: Font): string {
    switch (font) {
        case 'giphy':
            return `"nexablack"`
        case 'meme':
            return `"meme"`
        case 'fancy':
            return `"Brush Script MT", cursive`
        case 'pixel':
            return `"emulogic"`
        case 'subtitle':
            return 'interface bold'
    }
}

export function fontScale(font: Font): number {
    switch (font) {
        case 'meme':
            return 1.2
        case 'fancy':
            return 1.4
        case 'pixel':
            return 0.7
        default:
            return 1
    }
}

export function fontTitle(font: Font): string {
    switch (font) {
        case 'giphy':
            return 'GIPHY'
        case 'meme':
            return 'MEME'
        case 'fancy':
            return 'Fancy'
        case 'pixel':
            return 'Pixel'
        case 'subtitle':
            return 'Subtitle'
    }
}

export function fontUrl(font: Font): string {
    switch (font) {
        case 'giphy':
            return '/static/webfonts/nexa_black-webfont.woff'
        case 'meme':
            return '/static/webfonts/meme.woff'
        case 'pixel':
            return '/static/webfonts/emulogic.woff'
        case 'subtitle':
            return '/static/webfonts/InterFace_W_Bd.woff'
        default:
            return ''
    }
}
